import { JsonConvert, OperationMode, ValueCheckingMode } from 'json2typescript';

export class JsonUtil {
  private static jsonConvertInstance = null;

  private static getJsonConvert(): JsonConvert {
    if (JsonUtil.jsonConvertInstance) {
      return JsonUtil.jsonConvertInstance;
    }
    JsonUtil.jsonConvertInstance = new JsonConvert();
    JsonUtil.jsonConvertInstance.operationMode = OperationMode.ENABLE; // print some error data
    JsonUtil.jsonConvertInstance.ignorePrimitiveChecks = true; // allow assigning number to string etc.
    JsonUtil.jsonConvertInstance.valueCheckingMode = ValueCheckingMode.ALLOW_NULL; // allow null
    return JsonUtil.jsonConvertInstance;
  }

  public static jsonConvert(json: any, classReference: new () => any): any {
    if (json) {
      let result = {};
      try {
        result = JsonUtil.getJsonConvert().deserialize(json, classReference);
      } catch (e) {
        console.log(e);
      }
      return result;
    } else {
      return undefined;
    }
  }

  public static jsonSerialize(data: any) {
    return JsonUtil.getJsonConvert().serialize(data);
  }

  /**
   *å­ç¬¦ä¸²è½¬json
   *
   */
  public static stringToJson(data) {
    return JSON.parse(data);
  }

  /**
   *jsonè½¬å­ç¬¦ä¸²
   */
  public static jsonToString(data) {
    return JSON.stringify(data);
  }

  /**
   *mapè½¬æ¢ä¸ºjson
   */
  public static mapToJson(map) {
    return JSON.stringify(JsonUtil.strMapToObj(map));
  }

  /**
   *jsonè½¬æ¢ä¸ºmap
   */
  public static jsonToMap(jsonStr) {
    return JsonUtil.objToStrMap(JSON.parse(jsonStr));
  }

  /**
   *mapè½¬åä¸ºå¯¹è±¡ï¼mapææé®é½æ¯å­ç¬¦ä¸²ï¼å¯ä»¥å°å¶è½¬æ¢ä¸ºå¯¹è±¡ï¼
   */
  public static strMapToObj(strMap) {
    let obj = Object.create(null);
    for (let [k, v] of strMap) {
      obj[k] = v;
    }
    return obj;
  }

  /**
   *mapè½¬åä¸ºå¯¹è±¡
   */
  public static mapToObj(map: Map<any, any>) {
    let obj = {};
    map.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }

  /**
   *å¯¹è±¡è½¬æ¢ä¸ºMap
   */
  public static objToStrMap(obj, keyIsNumber?: boolean, valueIsNumber?: boolean) {
    let map = new Map();
    let key: any;
    let value: any;
    for (let k of Object.keys(obj)) {
      key = k;
      value = obj[k];
      if (keyIsNumber) {
        key = +key;
      }
      if (valueIsNumber) {
        value = +value;
      }
      map.set(key, value);
    }
    return map;
  }

  /**
   *æ°ç»è½¬æ¢ä¸ºMap
   */
  public static objArrayToMap(keyName, objArray: any[] = []) {
    let map = new Map();
    objArray.forEach(obj => {
      map.set(obj[keyName], obj);
    });
    return map;
  }
}
